import axios from "../../../utils/authAxios";
const api_base_url =
  process.env.REACT_APP_API_BASEURL + "/LeasedEquipmentConfiguration";

export const getLeasedEquipmentMakeList = async () => {
  return axios.get(`${api_base_url}/GetMake`).then((res) => {
    return res;
  });
};

export const addLeasedEquipmentMake = async (newMake) => {
  const { data } = await axios.post(`${api_base_url}/AddMake`, {
    ...newMake,
  });
  return data;
};

export const deleteLeasedEquipmentMake = async (ids) => {
  const { data } = await axios.delete(`${api_base_url}/DeactivateMake`, {
    data: ids,
  });
  return data;
};

export const updateLeasedEquipmentMake = async (editLeasedEquipmentMake) => {
  const { data } = await axios.put(
    `${api_base_url}/EditMake`,
    editLeasedEquipmentMake
  );
  return data;
};
